import { Link, usePage } from "@inertiajs/react";
import clsx from "clsx";
import type { PublicProps } from "@/types";
import { navItemsFor } from "./NavItems";
import Icon from "@/components/ui/Icon";

// Boba Bash is an in-person event, so phones are the primary surface: nav lives
// in a thumb-reachable tab bar below `lg`, and the rail takes over above it.
export default function BottomNav() {
  const { props, url } = usePage<PublicProps>();
  const items = navItemsFor(props.user, props.program);

  if (!props.user) return null;

  return (
    <nav className="border-line bg-surface fixed inset-x-0 bottom-0 z-50 flex border-t-2 pb-[env(safe-area-inset-bottom)] lg:hidden">
      {items.map((item) => {
        const active = url.startsWith(item.link);

        return (
          <Link
            key={item.link}
            href={item.link}
            className={clsx(
              "font-display relative flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-bold transition-colors",
              active ? "bg-goldenrod text-ink" : "text-ink-muted",
            )}
          >
            <span className="relative">
              <Icon src={item.icon} className="h-6 w-6" />
              {(item.badge ?? 0) > 0 && (
                <span className="border-line bg-sunset-orange absolute -top-1 -right-2 flex h-4 min-w-4 items-center justify-center rounded-full border px-1 text-[10px] text-white">
                  {item.badge}
                </span>
              )}
            </span>
            {item.name}
          </Link>
        );
      })}
    </nav>
  );
}
